<template>
  <div class="main frame-details" id="details">
    <div class="frame-bg">
      <img class="frame-img" src="/assets/images/frame-big.webp" alt v-rellax="rellax" />
      <img class="img-overlay" src="/assets/images/frame-big-up.webp" alt />
    </div>
    <div class="frame-overlay"></div>
    <div class="frame-content container-fluid">
      <div class="frame-page" id="warriors">
        <hero-carousel></hero-carousel>
      </div>
      <div
        class="frame-page d-flex flex-column"
        id="nfts"
        :data-aos="animation"
      >
        <div class="container text-center mb-5">
          <h1 class="mb-5">BECOME ODIN'S WARRIOR</h1>
          <p>
            9.999 fearless Warrior NFTs of ValhallaVerse are unique non-fungible tokens
            with ERC-721 standard.
          </p>
          <p>
            Warrior NFTs have up to 20 traits and more than 300 assets that will determine
            their stats randomly as they are minted.
          </p>
          <p>You will be able to lend/borrow and breed Warrior NFTs.</p>
          <p>
            Various collections based on different races & clans from Norse mythology will
            follow!
          </p>
        </div>
        <nft-carousel></nft-carousel>
      </div>
      <div
        class="frame-page d-flex flex-column"
        id="skillcards"
        :data-aos="animation"
      >
        <div class="container text-center">
          <h1 class="mb-5">
            BUILD YOUR <br />
            SKILL CARD DECK
          </h1>
          <p class="mb-1">
            Skill cards are non-fungible tokens with ERC-1155 standard and
            <br />
            they are the essential components to empower your Warrior NFT<br />
            in Arena, Dungeon & Adventure game modes.
          </p>
        </div>
        <card-carousel></card-carousel>
      </div>
      <div class="frame-page container" id="tokens" :data-aos="animation">
        <token></token>
      </div>
      <div class="frame-page container" id="partners" :data-aos="animation">
        <logos></logos>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import Leaves from "@/components/Leaves.vue";
import HeroCarousel from "@/components/HeroCarousel.vue";
import NftCarousel from "@/components/NftCarousel.vue";
import CardCarousel from "@/components/CardCarousel.vue";
import Token from "@/components/Token.vue";
import Logos from "@/components/Logos.vue";
import Foot from "@/components/Foot.vue";

export default {
  data() {
    return {
      rellax: {
        speed: 1,
      },
      animation: "fade-up",
    };
  },
  mounted() {
    console.log(this);
    if (this.$device.mobile) this.animation = "";
  },
  components: {
    Leaves,
    HeroCarousel,
    NftCarousel,
    CardCarousel,
    Token,
    Logos,
    Foot,
  },
};
</script>

<style lang="scss" scoped>
.frame-details {
  position: relative;
  width: 100%;
  overflow: hidden;
  .frame-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    .frame-img {
      object-fit: cover;
      width: 100%;
      @media (max-width: 767.98px) {
        width: 240%;
      }
    }
    .img-overlay {
      object-fit: cover;
      position: absolute;
      width: 100%;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      @media (max-width: 767.98px) {
        width: 240%;
        transform: translateX(-22%);
      }
      &.shadow {
        -webkit-filter: drop-shadow(0px 0px 1rem #fff);
        filter: drop-shadow(0px 0px 1rem #fff);
      }
    }
  }
  .frame-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @media (max-width: 767.98px) {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 99%, rgba(0, 0, 0, 1) 100%);
    }
  }
  .frame-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-top: 0rem;
    @media (max-width: 767.98px) {
      display: block;
    }
    @media (min-width: 1200px) and (max-width: 1440px) {
      padding-top: 1rem;
    }
    @media (min-width: 1440.02px) and (max-width: 1600px) {
      padding-top: 0rem;
    }
    @media (min-width: 1600.02px) and (max-width: 1920px) {
      padding-top: 1rem;
    }
    @media (min-width: 1920.02px) {
      padding-top: 2rem;
    }
    .frame-page {
      min-height: 667px;
      min-height: 100vh;
      max-height: 1600px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 22%;
      padding-top: 2rem;
      padding-bottom: 6rem;
      h1 {
        font-family: "Loki";
        @media (max-width: 767.98px) {
          font-size: 2rem;
        }
      }
    }
    #warriors {
      @media (max-width: 767.98px) {
        padding-left: 0;
      }
    }
    #nfts h1 {
      color: #ffeec2;
    }
    #skillcards h1 {
      color: #ffeec2;
    }
    #partners {
      flex: 0 0 12%;
      min-height: 50vh;
    }
  }
}
</style>
